export default "__VITE_ASSET__wno2zFcE__"